/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

/**
 * Module imports.
 */
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CalendarModule } from 'primeng/calendar';

/**
 * Component imports.
 */
import { DatepickerComponent } from './datepicker.component';
import { TimePickerComponent } from '../time-picker/time-picker.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [
    DatepickerComponent,
    TimePickerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    BsDatepickerModule,
    NgbModule,
    CalendarModule
  ],
  exports: [
    DatepickerComponent,
    TimePickerComponent
  ]
})
export class DatePickerModule { }
